import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { cn } from "../../../lib/utils";

interface DocsBreadcrumbsProps {
  className?: string;
}

export function DocsBreadcrumbs({ className }: DocsBreadcrumbsProps) {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Don't show breadcrumbs on home page
  if (pathnames.length <= 1) {
    return null;
  }

  return (
    <nav
      className={cn("flex items-center gap-2 text-sm mb-6", className)}
      aria-label="Breadcrumb"
    >
      <Link
        to="/docs"
        className="flex items-center gap-1 text-[var(--su-text-muted)] hover:text-[var(--su-text-primary)] transition-colors"
      >
        <Home className="w-4 h-4" />
        <span>Docs</span>
      </Link>

      {pathnames.slice(1).map((name, index) => {
        const routeTo = `/docs/${pathnames.slice(1, index + 2).join("/")}`;
        const isLast = index === pathnames.length - 2;

        return (
          <React.Fragment key={routeTo}>
            <ChevronRight className="w-4 h-4 text-[var(--su-text-muted)]" />
            {isLast ? (
              <span className="text-[var(--su-text-primary)] font-medium">
                {name
                  .split("-")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
              </span>
            ) : (
              <Link
                to={routeTo}
                className="text-[var(--su-text-muted)] hover:text-[var(--su-text-primary)] transition-colors"
              >
                {name
                  .split("-")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
